<template>
  <table class="table" :class="{'table_red': red, 'table_gray': gray, }">
    <spinner-el class="spinner" v-if="showTableSpinner"/>
    <thead>
      <slot name="thead"></slot>
    </thead>
    <transition-group v-if="animated" class="tbody" tag="tbody" name="list">
      <slot name="tbody"></slot>
    </transition-group>
    <tbody v-else class="tbody">
      <slot name="tbody"></slot>
    </tbody>
  </table>
</template>


<script>
export default {
  props: {
    showTableSpinner: {
      type: Boolean,
    },
    red: {
      type: Boolean,
    },
    gray: {
      type: Boolean,
    },
    animated: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  border-collapse: collapse;
  thead {
    tr {
      th {
        font-weight: 600;
        line-height: 17px;
        text-transform: uppercase;
        border-bottom: 1px solid transparent;
      }
    }
  }
  &_red {
    thead {
      tr {
        background: $red-color5;
      }
      th {
        @include font(11px, $red-color3);
      }
    }
  }
  &_gray {
    thead {
      tr {
        background: $grey-color6;
      }
      th {
        @include font(11px, $grey-color2);
      }
    }
  }
  tbody {
    td {
      @include font(12px, $black-color1, 500);
    }
  }
}

th {
  padding: 12px 60px;
}
td {
  padding: 23px 60px;
}

  .table {
    position: relative;
  }

  .spinner {
    position: absolute !important;
    z-index: 3;
    left: 50%;
    margin-left: -30px;
    top: calc(50vh - 40px);
  }
</style>



// WEBPACK FOOTER //
// src/components/uikit/TableEl.vue